// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation-module--navigation--h-7dk"};